import { ContextStore } from '@src/contexts/AppContextStore/context-store'
import { createContext, useContext, useEffect, useMemo } from 'react'

export type AppContextStoreValue = {
  contextStore?: ContextStore
}

const AppContextStore = createContext<AppContextStoreValue>({})

export const useAppContextStore = () => useContext(AppContextStore)

export const AppContextStoreProvider = (props: { contextStore: ContextStore; children?: any }) => {
  const value = useMemo(() => {
    return {
      contextStore: props.contextStore,
    }
  }, [props.contextStore])

  useEffect(() => {
    value.contextStore.set('APP_IS_MOUNTED', true)
  }, [])

  return <AppContextStore.Provider value={value}>{props.children}</AppContextStore.Provider>
}
